module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container",
    class: {
      'modal-lg': _vm.modalSize == 'large', 'modal-sm': _vm.modalSize == 'small'
    }
  }, [_c('header', [_c('h3', [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), (_vm.hasCloseHandler) ? _c('button', {
    staticClass: "btn btn-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loaded) ? _vm._t("default") : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2), _vm._v(" "), (_vm.loaded && _vm.hasSaveHandler && !_vm.saveDisabled) ? _c('footer', [_c('button', {
    staticClass: "btn btn-custom",
    attrs: {
      "disabled": _vm.saveDisabled,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [(_vm.saved) ? _c('i', {
    staticClass: "fa fa-check fa-lg fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-lg fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                     Save\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-errors"
  }, [_vm._t("errors")], 2)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e25ea21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/BaseModal.vue
// module id = 641
// module chunks = 0